export default __webpack_public_path__ + "static/media/section2-background.63acad98.jpg";